import { Palette, CheckCircle2 } from 'lucide-react';
import BrandPriorities from './BrandPriorities';

/**
 * Brand & Priorities profile tab. Clients edit their own; admins/team view a
 * selected client's submission (still editable so they can help maintain it).
 */
export default function BrandPrioritiesPage({ user, selectedClient }) {
  const isViewingAsAdmin = selectedClient && user.role !== 'client';
  const firmId = isViewingAsAdmin ? selectedClient.firmId : user.firm?.id;

  if (!firmId) {
    return <div className="p-8 text-slate-400" data-testid="brand-priorities-nofirm">Select a client to view their Brand &amp; Priorities.</div>;
  }

  return (
    <div className="max-w-4xl animate-fadeInUp" data-testid="brand-priorities-page">
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center shadow-lg shadow-violet-500/30">
            <Palette className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>Brand &amp; Priorities</h1>
            <p className="text-sm text-slate-500">
              {isViewingAsAdmin ? `${selectedClient.name}'s brand assets and focus areas` : 'Your brand assets and what matters most to your firm'}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-6 sm:p-8">
        <BrandPriorities firmId={firmId} variant="page" />
      </div>

      <p className="text-xs text-slate-400 mt-4 flex items-center gap-1.5">
        <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />
        You can update your brand and priorities any time — just save your changes.
      </p>
    </div>
  );
}
